import React from 'react';
import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { AspectRatio } from '@jucy-ui/components';
import { CmsLinkImage } from '@/services/cms/models/CmsImageLink';
import { MarketingCampaignBlockImagesGridCell } from './MarketingCampaignBlockImagesGridCell';

export interface MarketingCampaignBlockImagesGridProps {
    images: CmsLinkImage[];
    sx?: SxProps<Theme>;
}

export const MarketingCampaignBlockImagesGrid = ({ images, sx }: MarketingCampaignBlockImagesGridProps) => (
    <AspectRatio ratio={2.59090909} sx={sx}>
        <Box>
            <Box
                sx={(theme) => ({
                    width: '100%',
                    height: '100%',
                    display: {
                        xs: 'block',
                        sm: 'grid',
                    },
                    gridGap: {
                        sm: theme.spacing(2),
                        lg: theme.spacing(3),
                    },
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gridTemplateRows: '1fr 1fr',
                })}
            >
                {images.map((imageLink, i) => (
                    <MarketingCampaignBlockImagesGridCell key={imageLink.id} image={imageLink} position={i} />
                ))}
            </Box>
        </Box>
    </AspectRatio>
);
